// ----------------------------------------------------------------------
// Event Co-Organizers Translations - English
// ----------------------------------------------------------------------

export const coOrganizersEn = {
  co_organizers: {
    title: 'Co-Organizers',
    tab_title: 'Co-Organizers',
    description: 'Manage organizations that co-organize this event with you.',
    add_co_organizer: 'Add Co-Organizer',
    max_reached: 'Maximum of 2 co-organizers reached',
    search_placeholder: 'Search for an organization...',
    no_co_organizers: 'No co-organizers added yet.',
    no_co_organizers_description:
      'Add other organizations to collaborate on this event. You can add up to 2 co-organizers.',
    permissions: 'Permissions',
    view_general: 'View General Data',
    view_general_description: 'Access to General, Overview, and Preview tabs',
    view_sales: 'View Sales Data',
    view_sales_description: 'Access to Dashboard, Tickets Data, and Shares Distribution tabs',
    view_analytics: 'View Analytics',
    view_analytics_description: 'Access to the Analytics tab',
    edit_event: 'Edit Event',
    edit_event_description: 'Ability to edit General, Dates, Tickets, and Publish settings',
    remove: 'Remove Co-Organizer',
    remove_confirm:
      'Are you sure you want to remove this co-organizer? They will lose all access to this event.',
    added_success: 'Co-organizer added successfully',
    updated_success: 'Co-organizer permissions updated successfully',
    removed_success: 'Co-organizer removed successfully',
    cannot_add_self: 'Cannot add the main organizer as a co-organizer',
    already_added: 'This organization is already a co-organizer',
    max_error: 'Maximum 2 co-organizers allowed',
    co_organized_event: 'Co-organized',
    co_organizer_badge: 'Co-organizer',
    select_permissions: 'Select permissions for this co-organizer',
    no_results: 'No organizations found',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    add: 'Add',
    select_org: 'Select an organization',
    notification_view_event: 'View event',
  },
};
